import { render, staticRenderFns } from "./VerticalLabelComponent.vue?vue&type=template&id=f132c158&scoped=true&"
import script from "./VerticalLabelComponent.vue?vue&type=script&lang=js&"
export * from "./VerticalLabelComponent.vue?vue&type=script&lang=js&"
import style0 from "./VerticalLabelComponent.vue?vue&type=style&index=0&id=f132c158&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f132c158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins\\workspace\\Apps\\WebViewer\\Dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f132c158', component.options)
    } else {
      api.reload('f132c158', component.options)
    }
    module.hot.accept("./VerticalLabelComponent.vue?vue&type=template&id=f132c158&scoped=true&", function () {
      api.rerender('f132c158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\viewer\\components\\VerticalLabelComponent.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/viewer/components/VerticalLabelComponent.vue
// module id = 308
// module chunks = 0